import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const state = {
  rows: [],
  frameType: [],
  row: null,
  condition: {}
}

mutations.FRAMETYPE = function (state, payload) {
  state.frameType = payload
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0204CmsFramesService.searchDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo(SysUtils.MESSAGE.RECORD.NO_MATCH)
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null,
        files: {}
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0204CmsFramesService.getDataDetails', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  frameType: ({ commit, state }) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M205CmsFrameTypeService.getFrameTypeForSelect' } } })
      .then((data) => {
        commit('FRAMETYPE', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0204CmsFramesService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  deleteImage: ({ commit, state }, item) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0204CmsFramesService.deleteImage', input: item } } })
      .then((data) => {
        commit('EDIT', data.delete.output)
      })
  },
  bulkDelete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0204CmsFramesService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('FIND_ALL', data.delete.output)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0204CmsFramesService.saveDataDetails', input: row } } })
      .then((data) => {
        SysUtils.showSuccess(SysUtils.MESSAGE.RECORD.SAVED)
        commit('SAVE', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/Frame/FrameStore.js